import { useEffect, useState } from "react";

/**
 * Загрузка данных с отменой запроса.
 *
 * Раньше каждый fetch писался вручную и без AbortController: при быстрой смене
 * языка (или размонтировании) ответ старого запроса перезаписывал новый и
 * React ругался на setState после unmount.
 *
 * @param {(signal: AbortSignal) => Promise<T>} fetcher
 * @param {unknown[]} deps  Зависимости, при смене которых нужен новый запрос.
 * @param {{ initialData?: T }} options
 * @returns {{ data: T, loading: boolean, error: Error | null }}
 */
export function useApiResource(
  fetcher,
  deps = [],
  { initialData = null } = {},
) {
  const [state, setState] = useState({
    data: initialData,
    loading: true,
    error: null,
  });

  useEffect(() => {
    const controller = new AbortController();
    setState({ data: initialData, loading: true, error: null });

    fetcher(controller.signal)
      .then((data) => {
        if (controller.signal.aborted) return;
        setState({ data, loading: false, error: null });
      })
      .catch((error) => {
        if (controller.signal.aborted || error.name === "AbortError") return;
        setState({ data: initialData, loading: false, error });
      });

    return () => controller.abort();
    // fetcher намеренно не в зависимостях: он пересоздаётся на каждый рендер.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return state;
}

export default useApiResource;
